import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "../../pages/home";

function AppRouter() {
  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </div>
    </Router>
  );
}

export default AppRouter;
